import { Quote } from "lucide-react";
import { useLang } from "../i18n/LangContext";

export const QuoteBlock = ({ greek, translation, cite, note }) => {
  const { ui } = useLang();
  return (
    <figure
      data-testid={`quote-${cite ? cite.replace(/[^a-zA-Z0-9α-ωΑ-Ω]+/g, '-').toLowerCase() : 'passage'}`}
      className="my-8 rounded-lg border border-line bg-surface/70 p-6 md:p-8"
    >
      <div className="flex items-start gap-3">
        <Quote className="mt-1 h-5 w-5 shrink-0 text-terra" aria-hidden="true" />
        <blockquote className="greek-ancient text-ink/95">{greek}</blockquote>
      </div>
      {translation && (
        <p className="mt-4 border-t border-line pt-4 text-sm md:text-base leading-relaxed text-muted-foreground">
          {translation}
        </p>
      )}
      {cite && (
        <figcaption className="mt-3 text-xs font-semibold uppercase tracking-[0.18em] text-aegean">
          {cite}
        </figcaption>
      )}
      {note && (
        <p className="mt-3 text-sm leading-relaxed text-foreground/80">
          <span className="font-semibold text-terra">{ui.quoteNoteLabel} </span>
          {note}
        </p>
      )}
    </figure>
  );
};
